import gql from 'graphql-tag';

export default gql`
  mutation fetchBalances($portfolioId: ID!) {
    fetchBalances(portfolioId: $portfolioId)
  }
`;
